import OpeningBalances from "./OpeningBalances";

const ClosingBalances = (props) => (
  <OpeningBalances {...props} balanceView="closing" />
);

export default ClosingBalances;
